import * as React from 'react'
import {makeStyles} from '@mui/styles'
import RXRIcon from './RXRIcon'
import {Spacing} from '../assets/styles'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    flexDirection: 'column',
  },
  dataComingSoon: {
    marginTop: Spacing.spaceExtraExtraSmall,
  },
})

function DataComingSoon({iconSize}) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <RXRIcon icon={RXRIcon.HOUR_GLASS} size={iconSize || RXRIcon.SIZE_LARGE} />
      <div className={classes.dataComingSoon}>Data coming soon...</div>
    </div>
  )
}

export default DataComingSoon
